/*
 * @Description: SDK相关事件监听
 */
import jsBridge from '../common/jsBridge'
//import App from "../class/App";


function fireEvent (eventName, eventData) {
    var ev = document.createEvent('HTMLEvents')
    ev.initEvent(eventName, false, true)
    ev.param = eventData
    document.dispatchEvent(ev)
}

/**
 * @Description: 监听SDK的thirdPartyCalled事件，并转发到具体到事件监听上
 */
jsBridge.addEventListener('thirdPartyCalled', function(event){
    const {sq , action, params} = event.param
    console.log('thirdPartyCalled====>',event.param)
    fireEvent(getActionName(action), {sq, params})
})

/**
 * @Description: 监听SDK的thirdPartyCalled事件，监听器处理晚响应事件后调用该方法通知SDK处理结果
 */
export function thirdPartyCalledResponse (sq, params = {}) {
    const action = 'VideoBridge/thirdPartyCalledResponse'
    return jsBridge.callNative({
        fnName: action,
        params
    })
}

/**
 * 处理成功
 * @param resolve
 * @param sq
 * @returns {Function}
 */
function getResolve(resolve, sq){
    return function(ret = {}){
        const handleReponseData = {
            sq,
            code: 0,
            message: 'success',
            data: ret
        }
        resolve(handleReponseData)
    }
}

/**
 * 处理失败
 * @param reject
 * @param sq
 * @returns {Function}
 */
function getReject(reject, sq){
    return function(errMsg){
        const handleReponseData = {
            sq,
            code: 1,
            message: errMsg || 'failed'
        }
        reject(handleReponseData)
    }
}

/**
 * 对业务代码进行包装，用于对业务方对监听方法处理结果进行捕获，并将处理结果发送给sdk用于对处理结果的响应
 * @param actionHandle
 * @returns {Function}
 */
function decoratorEventHandle(actionHandle){
    return function (event){
        const nativeRequestData = event.param
        const {sq, params} = nativeRequestData
        const doHandle = new Promise((resolve, reject)=>{
            resolve = getResolve(resolve, sq)
            reject = getReject(reject, sq)
            actionHandle(params, resolve, reject)
            /*const ret = actionHandle(params, resolve, reject)
            if( typeof ret === 'object'){
                resolve(ret)
            }*/
        })
        doHandle.then((handleReponseData)=>{
            console.log('返回响应-then：',handleReponseData)
            thirdPartyCalledResponse(handleReponseData)
        }).catch((handleReponseData)=>{
            console.log('返回响应-catch：',handleReponseData)
            thirdPartyCalledResponse(handleReponseData)
        })
    }
}

const getActionName = (function(){
    const preStr = 'thirdPartyCalled-'
    return function (actionName){
        return preStr+actionName
    }
})()

const registerHandle__ = (function(){
    let calledMap = {
        /*
        'setStyle':{
            request: [{sq , action, params}],
            listenerList: []
        }
        */
    }

    function pushRequest(actionName, handle){

    }

    jsBridge.addEventListener('thirdPartyCalled---', function(event){
        const {sq , action, params} = event.param
        let actionCatch = calledMap[action]
        if(actionCatch){
            calledMap[action] = {
                request: [{sq , action, params}]
            }
        }else {
            actionCatch.request.push({sq , action, params})
            while(actionCatch.request.length>0){
                const req = actionCatch.request.pop()
                actionCatch.listenerList.forEach(item=>{
                    item(req)
                })
            }

        }
        fireEvent(getActionName(action), {sq, params})
    })

    return function(actionName, actionHandle) {
        //const _eventName = getActionName(actionName)
        const _eventHandle = decoratorEventHandle(actionHandle)
        //jsBridge.addEventListener(_eventName, _eventHandle)

    }

})()

function registerHandle(actionName, actionHandle) {
    const _eventName = getActionName(actionName)
    const _eventHandle = decoratorEventHandle(actionHandle)
    jsBridge.addEventListener(_eventName, _eventHandle)
}

/**
 * 开发者更改页面元素样式时触发
 * @param actionHandle | Function
 */
export function onNativeSetStyle (actionHandle) {
    registerHandle('setStyle', actionHandle)
}

/**
 * 开发者更改页面元素样式时触发
 * @param actionHandle | Function
 */
export function onNativeSetStyleList (actionHandle) {
    registerHandle('setStyleList', actionHandle)
}



/**
 * 开发者通知展示关闭按钮时触发
 * @param actionHandle | Function
 */
export function onNativeShowCloseButton (actionHandle) {
    registerHandle('showCloseButton', actionHandle)
}

/**
 * 开发者通知隐藏关闭按钮时触发
 * @param actionHandle | Function
 */
export function onNativeHideCloseButton (actionHandle) {
    registerHandle('hideCloseButton', actionHandle)
}

/**
 * 开发者更改音量设置时触发
 * @param actionHandle | Function
 */
export function onNativeSetVolume (actionHandle) {
    registerHandle('setVolume', actionHandle)
}

/**
 * 开发者更改视频播放器播放模式时触发
 * @param actionHandle | Function
 */
export function onNativeSetVideoPlayMode (actionHandle) {
    registerHandle('setVideoPlayMode', actionHandle)
}




